<template>
  <div class="block hero">
    <div class="wrapper">
      <div class="portrait">
        <div class="image">
          <img :src="media" alt=""/>
        </div>
        <div class="info" v-if="body">
          <div v-html="body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BlockHero',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      content: {
        type: Object,
        default: null,
      },
      odd: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      body() {
        const body = this.content?.body || null;
        return (body && /\S/g.test(body)) ? body : null;
      },
      media() {
        const media = this.content?.media || null;
        if (media && media.length > 0) {
          return `${this.$b.contentUrl}/${media[0]?.full || media[0]?.path}`;
        }
        return null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.block.hero {
  position: relative;
  width: 100%;
  max-width: 984px;
  margin: 0 auto 100px auto;

  @include screen-mobile {
    margin-bottom: 40px;
  }

  & > .wrapper {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;

    @include screen-mobile {
      padding-bottom: initial;
      margin-left: -16px;
      width: calc(100% + 32px);
    }

    .portrait {
      position: absolute;
      margin: 0 auto;
      width: 100%;
      height: 100%;

      @include screen-mobile {
        position: relative;
      }

      & > .image {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;

        & > img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(1, 1);
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0;

          animation-name: blur-focus;
          animation-duration: 1.2s;
          animation-delay: 250ms;
          animation-fill-mode: forwards;

          @include screen-mobile {
            position: relative;
            top: 0;
            left: 0;
            animation-name: blur-focus-mobile;
          }
        }
      }


      & > .info {
        position: absolute;
        right: -20px;
        bottom: -20px;
        background: rgba(255, 255, 255, .85);
        padding: 20px 50px 20px 30px;
        box-shadow: 8px 8px 5px rgba(0, 0, 0, .1);
        opacity: 0;

        @include screen-mobile {
          position: relative;
          right: auto;
          bottom: auto;
          width: calc(100% - 20px);
          left: 10px;
          top: -16px;
          box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
          padding: 20px 20px 20px 30px;
        }

        animation-name: from-right;
        animation-delay: 0.85s;
        animation-duration: 0.8s;
        animation-fill-mode: forwards;

        & > em {
          position: absolute;
          display: block;
          pointer-events: none;
          width: 50px;
          height: 50px;
          border-color: black;
          border-style: solid;
          border-width: 1px;

          &:first-of-type {
            bottom: -1px;
            left: -1px;
            border-top-width: 0;
            border-right-width: 0;
          }
          &:last-of-type {
            top: -1px;
            right: -1px;
            border-left-width: 0;
            border-bottom-width: 0;
          }
        }

        & > a {
          display: block;
        }
      }
    }
  }
}
</style>
